import { Tooltip } from "antd";

function AppTooltip({
  children,
  label,
  title,
  className,
  overlayClassName,
  placement,
  align,
  arrow,
  autoAdjustOverflow,
  color,
  defaultOpen,
  destroyOnHidden,
  fresh,
  getPopupContainer,
  mouseEnterDelay,
  mouseLeaveDelay,
  trigger,
  open,
  zIndex,
  onOpenChange,
  ...props
}) {
  return (
    <Tooltip
      aria-label={label}
      title={title}
      classNames={{ root: `common-tooltip ${overlayClassName || ""}` }}
      placement={placement}
      align={align}
      arrow={arrow}
      autoAdjustOverflow={autoAdjustOverflow}
      color={color}
      defaultOpen={defaultOpen}
      destroyOnHidden={destroyOnHidden}
      fresh={fresh}
      getPopupContainer={getPopupContainer}
      mouseEnterDelay={mouseEnterDelay}
      mouseLeaveDelay={mouseLeaveDelay}
      trigger={trigger}
      open={open}
      zIndex={zIndex}
      onOpenChange={onOpenChange}
      className={className}
      {...props}
    >
      {children}
    </Tooltip>
  );
}

export default AppTooltip;
